/*
 * Copyright (c) 2023 Trimble Inc. All rights reserved.
 */

import { sendRequestAndReceiveResponse, toUrlLookupBody } from '../common/common';
import { GetGeneralServiceInformationEndpoint } from '../common/constants';

import { getServiceTicketEndpoint, getServiceBulletinsURLEndPoint, GetGeneralServiceInformationURLEndpoint } from '../common/constants';
import { loadFromLocalStorage   } from '../common/localStorage';

const GS_BULLETIN_DETAIL = 'GS_BULLETIN_DETAIL';
const STOP_GS_LOADING = 'STOP_GS_LOADING';
const CLEAR_GS_LIST = 'CLEAR_GS_LIST';
const UPDATE_GSINFO = 'UPDATE_GSINFO';
const LOAD_GS_INFO = 'LOAD_GS_INFO';
const UPDATE_GS_DATA = 'UPDATE_GS_DATA';

const LOADING_GS_INFORMATION = 'LOADING_GS_INFORMATION';
const GENERAL_SERVICE_DATA = 'GENERAL_SERVICE_DATA';
const LOADING_GSBULLETIN_DETAIL = 'LOADING_GSBULLETIN_DETAIL';
const UPDATE_SEARCH_INFO = 'UPDATE_SEARCH_INFO';
const CLEAR_VIEW_GS_STORE = 'CLEAR_VIEW_GS_STORE';

const initialState = {
    data: {},
    AllGSData: {},
    searchInfo: '',
    isAuthenticatedOnce: false,
    isGSLoading: false,
    isGSDetailLoading: false,

}

export const actionCreators = {
    LoadGeneralServiceInformation: (filter: any) => async (dispatch: any, getState: any) => {

        dispatch({ type: LOADING_GS_INFORMATION, filter });
        const gsData = await sendRequestAndReceiveResponse(
            JSON.stringify({
                'SearchText': '',
                'GSInfoType': filter
            }), GetGeneralServiceInformationEndpoint);
         console.log(gsData);
        dispatch({ type: GENERAL_SERVICE_DATA, gsData });
    },
    selectGSBulletin: (selectedBulletin: any) => async (dispatch: any, getState: any) => {

        dispatch({ type: LOADING_GSBULLETIN_DETAIL });
        if (selectedBulletin.url != '') {
            if (selectedBulletin.url.includes('docushare')) {
                const requestBody = {
                    TicketGrantingTicketUrl: window.atob(loadFromLocalStorage("TGT")),
                    ServiceName: 'http://trl.trimble.com/docushare/sso_login?location=' + selectedBulletin.url
                };
                const userId: string = loadFromLocalStorage('AuthToken');
                const encodedToken = 'Bearer ' + userId;
                const headerDict: any = {
                    'Authorization': encodedToken,
                    'Content-Type': 'application/json'
                };
                const response: any = await fetch(getServiceTicketEndpoint, {
                    headers: new Headers(headerDict),
                    body: JSON.stringify(requestBody),
                    method: 'POST'
                });
                const responseData = await response.json();
                console.log(responseData);
                if (response.body !== undefined) {
                    const url = `https://trl.trimble.com/docushare/sso_login?location=${  selectedBulletin.url  }&ticket=${  responseData.serviceTicket}`;
                    console.log(url);
                    selectedBulletin.url = url;

                }
            }
            else {
                if (selectedBulletin.isauthenticated !== true) {
                    if (selectedBulletin.documentType===1 ) {
                        const BulletinUrl = await sendRequestAndReceiveResponse(
                            toUrlLookupBody(selectedBulletin.url)
                            , getServiceBulletinsURLEndPoint);
                        selectedBulletin.url = BulletinUrl.presignedURL;
                        selectedBulletin.isauthenticated = true;
                        console.log(BulletinUrl.presignedURL);

                    }
                    else {
                        const gsUrl = await sendRequestAndReceiveResponse(
                            toUrlLookupBody(selectedBulletin.url)
                            , GetGeneralServiceInformationURLEndpoint);
                        selectedBulletin.url = gsUrl.presignedURL;
                        selectedBulletin.isauthenticated = true;
                        console.log(gsUrl.presignedURL);

                    }
                    
                }
            }
        }
        dispatch({ type: GS_BULLETIN_DETAIL, selectedBulletin });
    },

      UpdateGSInfo: (gsinfo: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_GSINFO, gsinfo });
    },

    
     LoadGSNumber: (searchinfo: any) => async (dispatch: any, getState: any) => {
         dispatch({ type: LOAD_GS_INFO, searchinfo });
    },
    UpdateSearchInfo: (searchinfo: any) => async (dispatch: any, getState: any) => {
        dispatch({ type: UPDATE_SEARCH_INFO, searchinfo });
    },
    filterGSInfo: (filtervalue: any, Gsdata: any) => async (dispatch: any, getState: any) => {
        console.log(filtervalue);
        console.log(Gsdata);
        dispatch({ type: UPDATE_GS_DATA, Gsdata });
    },
    StopGSLoading: () => async (dispatch: any, getState: any) => {
        dispatch({ type: STOP_GS_LOADING });
    },
    ClearGSList: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_GS_LIST });
    },

    ClearGSStore: () => async (dispatch: any, getState: any) => {
        dispatch({ type: CLEAR_VIEW_GS_STORE });
    },
}

export const reducer = (state: any, action: any) => {
    state = state || initialState;

    switch (action.type) {
        case GENERAL_SERVICE_DATA:
            return {
                ...state,
                isGSLoading: false,
                generalServiceData: action.gsData,
                AllGSData: action.gsData,
                serialNumber: '',
            };
        case LOADING_GS_INFORMATION:
            return {
                ...state,
                isGSLoading: true,
            };
        case GS_BULLETIN_DETAIL:
            return {
                ...state,
                isGSDetailLoading: false,
                selectedBulletin: action.selectedBulletin,
                isAuthenticatedOnce: true
            };
        case LOADING_GSBULLETIN_DETAIL:
            return {
                ...state,
                isGSDetailLoading: true
            };
        case UPDATE_GSINFO:
            return {
                ...state,
                generalServiceData: action.gsinfo,
                AllGSData: action.gsinfo,
                isGSLoading: false,
            };
        case LOAD_GS_INFO:
            return {
                ...state,
                isGSLoading: true,
                searchInfo: action.searchInfo,
                selectedBulletin: undefined
            };
        case UPDATE_SEARCH_INFO:
            return {
                ...state,
                searchInfo: action.searchinfo
            };
        case STOP_GS_LOADING:
            return {
                ...state,
                isGSLoading: false
            };
        case UPDATE_GS_DATA:
            return {
                ...state,
                generalServiceData: action.Gsdata
            };
        case CLEAR_GS_LIST: {
            return {
                ...state,
                serviceBulletinData: undefined
            };
        }
        case CLEAR_VIEW_GS_STORE: {
            return initialState;
        }

    }

    return state;
};
